import { reachAndResolve } from '@framework/validation';
import { FieldValues } from 'react-hook-form';
import { IFormAugmentedContext } from '../form/augmented/FormAugmentedContext';
import { VALIDATION_VALUES } from '../resolver/validationValuesKey';

/**
 * Risolve lo schema del campo `name` con i valori correnti del form.
 * `VALIDATION_VALUES` va nel context come in `yupMemoizedResolver`, così
 * asterisco e validazione leggono lo stesso stato.
 */
export function getAugmentedSchema(
  augmented: IFormAugmentedContext,
  values: FieldValues,
  name: string,
) {
  try {
    return reachAndResolve(augmented.schema, name, values, {
      ...augmented.validationContext,
      [VALIDATION_VALUES]: values,
    });
  } catch (e) {
    return null;
  }
}
